<template>
  <v-card outlined>
    <div class="d-flex align-center px-3 py-2">
      <v-icon small class="mr-2">mdi-account</v-icon>

      <template v-if="customer">
        <div class="min-w-0 flex-grow-1">
          <div class="cust-name">{{ customer.name }}</div>
          <div class="cust-sub">
            <span v-if="customer.phone">{{ customer.phone }}</span>
            <span v-if="customer.customerCode"> · {{ customer.customerCode }}</span>
          </div>
        </div>
        <v-btn small text @click="clear">
          <v-icon left small>mdi-close</v-icon>Walk-in
        </v-btn>
      </template>

      <template v-else>
        <v-chip color="primary" small label class="mr-2">Walk-in</v-chip>
        <span class="caption grey--text flex-grow-1">{{ use_language.general_customer }}</span>
        <!-- <v-btn small text color="primary" @click="openSearch">
          <v-icon left small>mdi-magnify</v-icon>ค้นหาลูกค้า
        </v-btn> -->
      </template>
    </div>

    <v-dialog v-model="searchDialog" max-width="640">
      <v-card>
        <v-card-title class="primary white--text">
          {{ use_language.search_customer }}
          <v-spacer />
          <v-btn icon dark @click="searchDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="6">
              <v-text-field v-model="search.name" :label="use_language.name" dense outlined hide-details @keyup.enter="doSearch" />
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="search.phone" :label="use_language.tel" dense outlined hide-details @keyup.enter="doSearch" />
            </v-col>
          </v-row>
          <div class="text-right my-2">
            <v-btn small color="primary" :loading="loading" @click="doSearch">{{ use_language.search }}</v-btn>
          </div>
          <v-data-table
            :headers="headers"
            :items="results"
            :items-per-page="5"
            dense
            @click:row="select"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import axios from 'axios'
import { shopService_dotnet } from '@/website/global'
import { get_languages } from '@/website/global_function'

export default {
  name: 'PosCustomerPicker',
  props: {
    customer: { type: Object, default: null }
  },
  data: () => ({
    use_language: {},
    header_token: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('authorization_token') },
    searchDialog: false,
    loading: false,
    search: { name: '', phone: '' },
    results: [],
    headers: []
  }),
  async created() {
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
    this.headers = [
      { text: this.use_language.name, value: 'name' },
      { text: this.use_language.code, value: 'customerCode' },
      { text: this.use_language.call, value: 'phone' }
    ]
  },
  methods: {
    get_languages,
    openSearch () {
      this.search = { name: '', phone: '' }
      this.results = []
      this.searchDialog = true
    },
    async doSearch () {
      if (!this.search.name && !this.search.phone) return
      this.loading = true
      try {
        const res = await axios.post(
          shopService_dotnet + 'Customer/get-customer-info-list',
          {
            shopID: localStorage.getItem('shop_id'),
            name: this.search.name,
            customerCode: '',
            phone: this.search.phone,
            line: '',
            email: '',
            facebook: '',
            address: '',
            isAscending: false,
            skip: 0,
            take: 20,
            orderBy: 1
          },
          { headers: this.header_token }
        )
        this.results = (res.data && res.data.customerList) || []
      } catch (err) {
        this.$swal({ position: 'top', type: 'error', text: err.message })
      }
      this.loading = false
    },
    select (row) {
      this.$emit('select', {
        id: row.id,
        name: row.name,
        phone: row.phone,
        customerCode: row.customerCode
      })
      this.searchDialog = false
    },
    clear () {
      this.$emit('select', null)
    }
  }
}
</script>

<style scoped>
.min-w-0 {
  min-width: 0;
}
.cust-name {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cust-sub {
  font-size: 10px;
  color: #90a4ae;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
